import React from "react";
import { formatPrice } from "../../util";

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    margin: "0 -5px -5px",
    justifyContent: "center"
  },
  seat: {
    border: "1px solid #ccc",
    padding: 10,
    margin: 5,
    position: "relative",
    flex: 1,
    width: "100%",
    boxSizing: "border-box"
  },
  largeSeat: {
    flex: 1,
    minWidth: "calc(25% - 10px)",
    maxWidth: "calc(25% - 10px)"
  },
  delete: {
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 5,
    cursor: "pointer",
    fontSize: "1.5em"
  },
  label: {
    fontSize: "1.5em",
    fontWeight: "bold"
  },
  ticket_bucket: {},
  price: {
    color: "#9e9e9e",
    marginLeft: 3
  }
};

function _sortSeats(a, b) {
  // sort by section/parent/own (i.e. Choir - A - 2)
  let sectionDelta = (a.seatmap_object.labels.section || "").localeCompare(
    b.seatmap_object.labels.section || ""
  );
  if (sectionDelta !== 0) {
    return sectionDelta;
  }
  let parentDelta = (a.seatmap_object.labels.parent || "").localeCompare(
    b.seatmap_object.labels.parent || ""
  );
  if (parentDelta !== 0) {
    return parentDelta;
  }
  let ownDelta = a.seatmap_object.labels.own - b.seatmap_object.labels.own;
  return ownDelta;
}

const OrderSeatList = (
  { seats, event, onRemoveSeat, containerRef },
  { isLarge }
) => {
  return (
    <div style={styles.container} ref={containerRef}>
      {seats.sort(_sortSeats).map(seat => {
        const variant = seat.variant
          ? seat.ticket_bucket.variants.find(v => v.id === seat.variant)
          : null;
        return (
          <div
            key={`${seat.seatmap_object.uuid || seat.seat}${
              seat.seatmap_object.numSelected
            }`}
            style={Object.assign({}, styles.seat, isLarge && styles.largeSeat, {
              borderLeft: `5px solid ${seat.seatmap_object.category.color}`
            })}
          >
            {onRemoveSeat ? (
              <div
                style={styles.delete}
                onClick={() => onRemoveSeat(seat.seat)}
              >
                ×
              </div>
            ) : null}
            <div style={styles.label}>{seat.seat}</div>
            <div style={styles.ticket_bucket}>
              {seat.ticket_bucket.name} {variant ? `– ${variant.name} ` : ""}
              <span style={styles.price}>
                (
                {formatPrice(
                  variant ? variant.price : seat.ticket_bucket.price,
                  /*short*/ true
                )}
                )
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

OrderSeatList.contextTypes = {
  isLarge: React.PropTypes.bool
};

export default OrderSeatList;



// WEBPACK FOOTER //
// ./src/app/components/partials/order-seat-list.jsx